const PROVIDER_POLICY = Object.freeze({
  google: Object.freeze({
    label: "Google",
    options: Object.freeze({ queryParams: Object.freeze({ prompt: "select_account" }) }),
  }),
  azure: Object.freeze({
    label: "Microsoft",
    options: Object.freeze({
      scopes: "email,profile",
      queryParams: Object.freeze({ prompt: "select_account" }),
    }),
  }),
});

export const AUTH_PROVIDERS = Object.freeze(Object.keys(PROVIDER_POLICY));

export async function startProviderSignInOnly(supabase, origin, provider) {
  if (!supabase?.auth || typeof supabase.auth.getSession !== "function") {
    throw Object.assign(new Error("Authentication is still loading."), { code: "auth_unavailable" });
  }
  const policy = PROVIDER_POLICY[provider];
  if (!policy) {
    throw Object.assign(new Error("This sign-in method is not available."), { code: "auth_provider_invalid" });
  }
  const normalizedOrigin = new URL(String(origin));
  if (normalizedOrigin.protocol !== "https:" && normalizedOrigin.hostname !== "localhost") {
    throw Object.assign(new Error("The sign-in return address is invalid."), { code: "auth_redirect_invalid" });
  }
  const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
  if (sessionError) throw sessionError;
  if (sessionData?.session) {
    throw Object.assign(
      new Error(`Sign out before starting ${policy.label} sign-in with another account.`),
      { code: "identity_linking_forbidden" },
    );
  }
  const result = await supabase.auth.signInWithOAuth({
    provider,
    options: {
      redirectTo: `${normalizedOrigin.origin}/`,
      ...policy.options,
    },
  });
  if (result.error) throw result.error;
  return result.data;
}

export function startGoogleSignInOnly(supabase, origin) {
  return startProviderSignInOnly(supabase, origin, "google");
}

export function startMicrosoftSignInOnly(supabase, origin) {
  return startProviderSignInOnly(supabase, origin, "azure");
}
